import { get_session_attendance_status } from "services/api-service";
import { get_devotee_filter_options } from "services/api-service";

export const REACT_APP_API_URL = "https://office.camsecai.com/api";
//export const REACT_APP_WEBSOCKET_URL = "wss://sukkhi.camsecai.com/api/wss/";
//export const REACT_APP_SOCKET_IO_URL = "https://sukkhi.camsecai.com/api/";
//export const REACT_APP_API_URL = "http://127.0.0.1:8001";
export const REACT_APP_WEBSOCKET_URL = "wss://office.camsecai.com/api/wss/";
export const REACT_APP_SOCKET_IO_URL = "https://office.camsecai.com/api/";

// Add this line to define it globally for the whole app
export const APP_CLIENT_NAME = "office";
export const SHOW_NOTIFICATION_TIMEOUT = 3000;

export const API_ROUTES = {
  login: "login",
  current_user_role: `/admin/current_user_role`,
  add_camera: "camera/add_camera",
  get_cameras: "camera/get_cameras",
  get_cameras_by_location: "camera/get_cameras_by_location",
  get_all_locations: "camera/get_all_locations",
  delete_camera: "camera/delete_camera",
  get_model_settings: "camera/get_model_settings",
  save_area_selection: "camera/add_area_selection",
  delete_area_settings: "camera/delete_area_settings",
  model_names: "camera/model_names",
  get_camera_image: "camera/get_camera_image",
  
  // Image Routes for Attendance
  get_staff_original_image: (id) => `events/image/staff/original/${id}`,
  get_staff_detected_image: (id) => `events/image/staff/detected/${id}`,
  get_member_original_image: (id) => `events/image/original/${id}`,
  get_member_detected_image: (id) => `events/image/detected/${id}`,
  
  // Image Routes for Suspects & Unknowns
  get_unknown_master_image: (id) => `unknowns/image/master/${id}`,
  get_unknown_log_image: (id) => `unknowns/image/log/${id}`,
  get_suspect_master_image: (id) => `suspects/image/master/${id}`,
  get_suspect_log_image: (id) => `suspects/image/log/${id}`,
  identify_customer: "students/identify_customer",
  
  // Student Image Route
  get_student_image: (id) => `students/image/${id}`,
  
  // Registered Staff Image Route
  get_staff_image: (id) => `staff/image/${id}`,
  
  add_course: "courses/add_course",
  get_courses: "courses/get_courses",
  delete_course: "courses/delete_course",

  create_session: "courses/create_session",
  get_sessions: "courses/get_sessions",
  edit_session: "courses/edit_session",
  delete_session: "courses/delete_session",
  get_attendance_summarys: "events/get_attendance_summary",
  get_all_hostels: "students/get_all_hostels",
  get_students_by_hostel: "students/get_students_by_hostel",

  download_csv: "events/download_csv",
  download_pdf: "events/download_pdf",
  get_events: "events/get_events",
  get_events_count: "events/get_events_count",
  get_event_image: "events/get_event_image",

  get_summary_data: "events/get_summary_data",
  get_counting_camera_dropdown: "events/get_dropdown",
  get_counting_data: "events/get_counting_data",
  get_summary_ids: "events/get_summary_ids",
  reset_camera_counting: "events/reset_camera_counting",
  
  // ✅ NEW: People Counting Analytics Route
  get_people_counting_analytics: "events/get_people_counting_analytics",

  upload_students_csv: "students/add_students_csv",
  upload_staff_csv: "staff/bulk_upload_staff_csv",
  filter_data: "reports/filter_data",
  get_summary: "reports/get_summary",
  download_summary_excel: "reports/download_summary_excel",
  get_summary_details: "reports/summary_details",
  download_summary_details_csv: "reports/download_summary_details_csv",
  get_home_page_summary: "reports/get_home_page_summary",
  get_live_class_summary: "reports/get_live_class_summary",
  getVideo: (id, name) => `reports/get_video/${id}&${name}`,
  assign_role: "admin/assign_role",
  remove_role: "admin/remove_role",
  get_attendance_by_role: "admin/get_attendance",
  get_students_by_role: "admin/get_students",
  attendance_summary_by_role: "admin/attendance_summary",
  all_users_with_roles: "admin/all_users_with_roles",

  // Role Management Dropdown Data
  get_distinct_sections: "admin/get_distinct_sections",
  get_distinct_hostels: "admin/get_distinct_hostels",

  add_student: "students/add_student",
  upload_students_zip: "students/upload_students_photos_zip",
  delete_student: "students/delete_student",
  get_students_by_session: "students/students_by_session",
  get_students_by_date: "students/students_by_date",
  get_all_students: "students/get_all_students",

  get_devotee_filter_options: "events/get_devotee_filter_options",
  get_all_registered_students: "students/get_all_registered_students",
  get_student: "students/get_student",
  update_student: "/students/update_student",
  delete_students: "/students/delete_student",
  get_staff_report: "staff/get_staff_report",
  get_staff_daily_breakdown: "staff/get_staff_daily_breakdown",
  get_staff_department_report: "staff/get_staff_department_report",
  add_student_leave: "students/leave-management/add",
  add_staff_leave: "staff/leave-management/add",
  get_staff_leaves: "staff/leave-management/list",
  update_staff_leave: "staff/leave-management/update",
  delete_staff_leave: "staff/leave-management/delete",
  add_suspect: "suspects/add_suspect",
  get_student_leaves: "students/leave-management/list",
  update_student_leave: "students/leave-management/update", 
  delete_student_leave: "students/leave-management/delete", 
  get_staff_trend_analysis: "staff/get_staff_trend_analysis",
  register_staff: "staff/register_staff",
  get_all_staff: "staff/get_all_staff",
  update_staff: "staff/update_staff",
  delete_staff: "staff/delete_staff",
  get_staff: "staff/get_staff",
  add_user: "users/add_user",
  get_all_user: "users/get_all_user",
  delete_user: "users/delete_user",
  user_image: "users/user_image",
  get_filtered_counting: "events/get_filtered_counting",
  get_emotions: "events/get_emotions",
  get_devotee: "events/get_devotee_summary",
  get_download_devotee_pdf: "events/download_devotee_pdf",
  check_duplicate: "students/check_duplicate",

  get_location_overviews: "events/get_location_overview",
  get_session_attendance_status: "events/get_session_attendance_status",
  get_locations_by_date: "events/get_locations_by_date",

  get_students_by_section: "students/get_students_by_section",
  get_unique_sections: "students/get_unique_sections",
  bulk_enroll_students: "students/bulk_enroll_students",
  get_location_report: "events/get_location_report",

  download_attendance_pdf: "events/download_attendance_pdf",
  getPeopleCountingLocations: "/reports/people-counting/data-by-date-time",

  get_staff_summary: "events/get_staff_summary",
  get_staff_stats: "events/get_staff_stats",
  download_staff_pdf: "events/download_staff_pdf",
  download_staff_csv: "events/download_staff_csv",

  get_unknown_location_report:   "unknowns/get_location_report",
  get_unknown_session_status:    "unknowns/get_session_attendance_status",
  get_unknown_locations_by_date: "unknowns/get_locations_by_date",
  get_unknown_person_detail:     "unknowns/get_person_detail",
  label_unknown_person:          "unknowns/label_person",
  get_unknown_summary:           "unknowns/summary",
};
